import {CATEGORIES_NO_DATA, CATEGORIES_LOADED} from './actions';

let init = {
  type: CATEGORIES_NO_DATA,
  payload: [],
};

export default function (_state_ = init, action) {
  let state = Object.assign({}, _state_);
  switch (action.type) {
    case CATEGORIES_NO_DATA:
      state.type = CATEGORIES_NO_DATA;
      state.payload = action.payload;
      return state;
    case CATEGORIES_LOADED:
      state.type = CATEGORIES_LOADED;
      state.payload = action.payload.categories;
      return state;
    default:
      return state;
  }
}
